export const ConversionEvents = {
  LANDING_VIEW: 'landing_view',
  PREVIEW_COMPLETED: 'preview_completed',
  SIGNUP: 'signup',
  LOGIN: 'login',
  DEMO_STARTED: 'demo_started',
  DEMO_COMPLETED: 'demo_completed',
  REPORT_GENERATED: 'report_generated',
  CHECKOUT_STARTED: 'checkout_started',
  SUBSCRIPTION_STARTED: 'subscription',
  SUBSCRIPTION_UPGRADED: 'subscription_upgraded',
  PROGRAM_INTEREST_SUBMITTED: 'program_interest_submitted',
  FEATURE_USED: 'feature_used',
  REFERRAL_SENT: 'referral_sent',
  REFERRAL_CONVERTED: 'referral_converted',
} as const;
